import { render, staticRenderFns } from "./EthicalMedicineTabs.vue?vue&type=template&id=555bd0c2&"
import script from "./EthicalMedicineTabs.vue?vue&type=script&lang=ts&"
export * from "./EthicalMedicineTabs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports